import FormField from '@/components/FormField/FormField';
import { reportsService } from '@/store/services/reports';
import { useReportPeriod } from '@/store/slices/reportFiltersSlice';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const periodMapper = {
  MONTH: 30,
  THREE_MONTHS: 90,
  SIX_MONTHS: 180,
  NINE_MONTHS: 270,
  ONE_YEAR: 365,
};

// Keys Type: "MONTH" | "THREE_MONTHS" | "SIX_MONTHS" | "NINE_MONTHS" | "ONE_YEAR"
export type PeriodKey = keyof typeof periodMapper;

export default function DatesFilters() {
  const { t } = useTranslation();
  const period = useReportPeriod();
  const result = useSelector(
    reportsService.endpoints.getReportPeriodsLK.select(undefined)
  );
  const data = result?.data;
  const periodCode = !!period
    ? data?.find((i) => i.id === period)?.code
    : 'MONTH';

  const disabledDateCustom = (current: Dayjs): boolean => {
    if (!current) return false;

    const today = dayjs().endOf('day');
    const daysAgo = dayjs()
      .subtract(periodMapper[periodCode as PeriodKey], 'day')
      .startOf('day');

    return current.isBefore(daysAgo) || current.isAfter(today);
  };

  return (
    <div className="grid grid-cols-2 gap-x-4">
      <FormField
        name="fromDate"
        id="fromDate"
        type="date"
        label={t('home.dateFrom')}
        placeholder="dd/mm/yyyy"
        customDisabledDate={disabledDateCustom}
        allowClear={false}
      />
      <FormField
        name="toDate"
        id="toDate"
        type="date"
        label={t('home.dateTo')}
        placeholder="dd/mm/yyyy"
        maxDate={dayjs()}
        allowClear={false}
      />
    </div>
  );
}
